import { fromJS } from 'immutable';


export const SET_LOYALTY_NUMBER = '@@storefront/SET_LOYALTY_NUMBER';
export const RESET_LOYALTY = '@@storefront/RESET_LOYALTY';


export const initialState = fromJS({
    loyaltyNumber: ''
});

// Reducers
export default function reducer(state = initialState, action) {
    switch (action.type) {
        case SET_LOYALTY_NUMBER:
            return state.set('loyaltyNumber', action.loyaltyNumber);

        case RESET_LOYALTY:
            return initialState;

        default:
    }
    return state;
}

export function setLoyaltyNumber(loyaltyNumber, segmentData) {
    return {
        type: SET_LOYALTY_NUMBER,
        loyaltyNumber,
        meta: {
            segment: {
                eventAction: 'Starcode Applied',
                eventData: segmentData
            }
        }
    };
}

export const resetLoyalty = () => ({
    type: RESET_LOYALTY
});
